/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { Fragment, useEffect, useRef, useState } from 'react';

import {
  CLUB,
  CLUB_CASUAL,
  FOOTBALL_TYPE_ID,
  FOOTBALL_TYPE_ID_NONE_ALL_SELECTION,
  KICKABOUT_CASUAL,
} from '../../const';
import filterMenuStyle from '../FiltersMenu/styles';
import { ToolTipIcon } from '../Icons';
import TooltipInfo from '../TooltipInfo';
import useStyles from './styles';

const TEAM_FOOTBALL = 'team-football';
const SESSIONAL_FOOTBALL = 'sessional-football';

const FilterByFootballType = ({
  onSave,
  currentValue: value,
  FootballTypeAllNone = 'All',
  filterShowHide,
}) => {
  const styles = useStyles();
  const filterMenuStyles = filterMenuStyle();

  const [currentValue, setCurrentValue] = useState(value);
  const lastSavedValue = useRef(value || '');

  const isTeamSelected =
    FootballTypeAllNone === 'All'
      ? currentValue === CLUB || currentValue === CLUB_CASUAL
      : false;
  const isSessionalSelected =
    FootballTypeAllNone === 'All'
      ? currentValue === KICKABOUT_CASUAL || currentValue === CLUB_CASUAL
      : false;

  const [isTeamFootball, setIsTeamFootball] = useState(isTeamSelected);
  const [isSessionalFootball, setIsSessionalFootball] =
    useState(isSessionalSelected);

  // Handle input change
  const handleCheckboxChange = e => {
    const { checked, value } = e.target;
    const val = Number(value);

    let newIsTeamFootball = isTeamFootball;
    let newIsSessionalFootball = isSessionalFootball;

    if (val === CLUB) {
      newIsTeamFootball = checked;
      setIsTeamFootball(checked);
    } else if (val === KICKABOUT_CASUAL) {
      newIsSessionalFootball = checked;
      setIsSessionalFootball(checked);
    }
    let finalValue = 0;
    if (newIsTeamFootball && newIsSessionalFootball) {
      finalValue = CLUB_CASUAL;
    } else if (newIsTeamFootball) {
      finalValue = CLUB;
    } else if (newIsSessionalFootball) {
      finalValue = KICKABOUT_CASUAL;
    }
    setCurrentValue(finalValue);
  };

  useEffect(() => {
    if (currentValue !== lastSavedValue.current) {
      onSave?.({
        [FOOTBALL_TYPE_ID]: currentValue || CLUB_CASUAL,
        [FOOTBALL_TYPE_ID_NONE_ALL_SELECTION]:
          currentValue > 0 ? 'All' : 'None',
      });
      lastSavedValue.current = currentValue;
    }
  }, [currentValue, onSave]);

  useEffect(() => {
    setCurrentValue(value);

    const newIsTeamSelected =
      FootballTypeAllNone === 'All'
        ? value === CLUB || value === CLUB_CASUAL
        : false;

    const newIsSessionalSelected =
      FootballTypeAllNone === 'All'
        ? value === KICKABOUT_CASUAL || value === CLUB_CASUAL
        : false;

    setIsTeamFootball(newIsTeamSelected);
    setIsSessionalFootball(newIsSessionalSelected);

    lastSavedValue.current = value || '';
  }, [value, FootballTypeAllNone]);

  return (
    <Fragment>
      <div css={filterMenuStyles.filterHead}>
        <h5 css={filterMenuStyles.filterTitle}>
          Football Type
          <span>
            <TooltipInfo icon={<ToolTipIcon />} headTitle="Football Type">
              <>
                <div>
                  <strong>Team football</strong>
                  Play in a team for training, matches, and competition against
                  other teams.
                </div>
                <div>
                  <strong>Sessional football</strong>
                  Play in a flexible way, suited to your lifestage and
                  lifestyle, regardless of age, gender or experience.
                </div>
              </>
            </TooltipInfo>
          </span>
        </h5>
      </div>
      <div css={filterMenuStyles.filterBody}>
        <ul css={styles.listWrapper}>
          <li>
            <label
              htmlFor={TEAM_FOOTBALL}
              css={styles.chooseFilter(isTeamSelected)}
            >
              <span>Team Football</span>
              <input
                type="checkbox"
                id={TEAM_FOOTBALL}
                name={TEAM_FOOTBALL}
                checked={isTeamSelected}
                value={CLUB}
                css={styles.optionCheckbox}
                onChange={handleCheckboxChange}
                tabIndex={filterShowHide ? 0 : -1}
              />
              <span /> {/* This is the visual checkbox controlled by CSS */}
            </label>
          </li>
          <li>
            <label
              htmlFor={SESSIONAL_FOOTBALL}
              css={styles.chooseFilter(isSessionalSelected)}
            >
              <span>Sessional Football</span>
              <input
                type="checkbox"
                id={SESSIONAL_FOOTBALL}
                name={SESSIONAL_FOOTBALL}
                checked={isSessionalSelected}
                value={KICKABOUT_CASUAL}
                css={styles.optionCheckbox}
                onChange={handleCheckboxChange}
                tabIndex={filterShowHide ? 0 : -1}
              />
              <span /> {/* This is the visual checkbox controlled by CSS */}
            </label>
          </li>
        </ul>
      </div>
    </Fragment>
  );
};

FilterByFootballType.propTypes = {
  currentValue: PropTypes.number,
  onSave: PropTypes.func,
  FootballTypeAllNone: PropTypes.string,
};

export default FilterByFootballType;
